(function (angular) {
    angular
        .module('one.admin')
        .controller('AddVideoModuleModalController', AddVideoModuleModalController);

    AddVideoModuleModalController.$inject = ['$scope', '$uibModalInstance', 'ModuleService', 'params'];

    function AddVideoModuleModalController($scope, $uibModalInstance, ModuleService, params) {
        $scope.module = {
            module_instance: {
                brand: 'default'
            }
        };

        angular.merge($scope, params);

        $scope.addVideoModule = addVideoModule;

        $scope.cancel = cancel;

        function addVideoModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
